export default "__VITE_ASSET__DcG3raBa__"